const Metrics = {
    SidePadding: ['8px', '16px', '48px'],
    Breakpoints: {
        small: '480px',
        medium: '600px',
        large: '1200px'
    }
}

export default Metrics
